import { mapValues, pick } from 'lodash-es'
import { FREEWEEK_PARAMS } from '~/utils/params'

export function getQueryFreeweekParams(query: Record<string, unknown>): Params {
  return mapValues(pick(query, Object.keys(FREEWEEK_PARAMS)), tryParseBoolean)
}
